import { render, staticRenderFns } from "./ClientNewForm.vue?vue&type=template&id=30841987"
import script from "./ClientNewForm.vue?vue&type=script&lang=ts"
export * from "./ClientNewForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports